import { render, staticRenderFns } from "./RealTimeNotifications.vue?vue&type=template&id=7b44d35a&scoped=true&"
import script from "./RealTimeNotifications.vue?vue&type=script&lang=js&"
export * from "./RealTimeNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b44d35a",
  null
  
)

export default component.exports